import { Base64 } from 'js-base64'
import * as appApi from '@/api/app'
import * as tool from '@/libs/tool'
export default {
  namespaced: true,
  state: {
    appInfo: {}
  },
  mutations: {
    setAppInfo (state, data) {
      state.appInfo = data
    }
  },
  actions: {
    getAppInfoBySite ({ commit }) {
      const site = 'https://hnxcja.ai.lvpin100.com'
      return new Promise((resolve, reject) => {
        appApi.getAppInfoBySite(Base64.encode(site)).then(res => {
          if (res.response.success && res.data) {
            commit('setAppInfo', res.data)
            tool.setAppId(res.data.appId)
            resolve({ success: true })
          } else {
            console.log('[ got an error response ]', res.response.msg)
            resolve({ success: false })
          }
        }).catch(error => {
          console.log('[ catch an error ]', error)
          reject(error)
        })
      })
    }
  },
  getters: {
    getAppInfo (state) {
      return state.appInfo
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/app.js